import fetch from "auth/FetchInterceptor";

const DashboardService = {};

DashboardService.fetchReport = function (params) {
  let url =
    "/get-dashboard-report?start_date=" +
    params.startDate +
    "&end_date=" +
    params.endDate;
  if (params.clientCompany) {
    url += "&client_company=" + params.clientCompany;
  }
  if (params.paymentMethod) {
    url += "&payment_method=" + params.paymentMethod;
  }
  return fetch({
    url,
    method: "get",
  });
};

export default DashboardService;
